import { render, staticRenderFns } from "./PostulantsListTest.vue?vue&type=template&id=60564ea2&scoped=true&"
import script from "./PostulantsListTest.vue?vue&type=script&lang=js&"
export * from "./PostulantsListTest.vue?vue&type=script&lang=js&"
import style0 from "./PostulantsListTest.vue?vue&type=style&index=0&id=60564ea2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60564ea2",
  null
  
)

export default component.exports